<template>
    <v-dialog width="400" v-model="dialog">
        <v-card class="pa-6">
            <v-card-title>Удалить услугу из акта?</v-card-title>
            <v-card-actions class="justify-end">
                <v-btn @click="dialog = false" color="gray" outlined rounded>отмена</v-btn>
                <v-btn @click="deleteService" color="gray" rounded class="white--text">Удалить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'DeleteServiceActDialog',
    props: ['value'],
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        deleteService() {
            this.$emit('confirmDeleteServiceAct');
        }
    }
};
</script>

<style scoped></style>
